import React from 'react';
import { createRoot } from 'react-dom/client';

import 'virtual:svg-icons-register';
import './sentryInit';
import '../shared/i18n';

import { App } from './App';
import { AppProviders } from './AppProviders';
import { enableMocking } from './enableMocking';

import '../shared/scss/index.scss';

if (import.meta.env.MODE === 'development') {
  await enableMocking();
}

const root = createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
